/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://wzddxgaws5ghdijn4u762bisay.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-iqn7vtncsvbubpcshqdxohwkiq",
    "aws_cloud_logic_custom": [
        {
            "name": "cacheClearApi",
            "endpoint": "https://jdqb7mafpf.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:c6827b83-f5f7-4625-9cc6-2c3fd424411c",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_aYqj2q8nQ",
    "aws_user_pools_web_client_id": "4ojqqs55aqf0hinob182f3b6rr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
